<template>
  <div v-if="isShown" class="alert" :class="{ error: variant === 'error', info: variant === 'info', thin }">
    <e-icon name="alert" class="alert-icon" />
    <div class="alert-content">
      <div class="w-100">
        <slot />
      </div>
      <e-icon v-if="closable" name="closeSvg" size="18" class="mr-1 alert-closer" @click="hideAlert" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { EIcon } from '@/core/components/ui';

defineProps<{
  variant?: 'error' | 'info' | 'warning';
  closable?: boolean;
  thin?: boolean;
}>();

const isShown = defineModel({ default: true });

const hideAlert = () => {
  isShown.value = false;
};
</script>

<style scoped lang="scss">
$parent: alert;

.alert {
  display: flex;
  align-items: center;

  box-sizing: border-box;

  padding: 16px;

  background-color: $warning-bg-color;
  border: 1px solid $warning-color;
  border-radius: $border-radius;

  &.thin {
    padding: 12px;
  }

  @include sm-and-down {
    padding: 10px 12px;
  }

  &.error {
    background-color: $alert-bg-color;
    border-color: $alert-color;

    .#{$parent}-icon {
      color: $alert-color;
    }
  }

  &.info {
    background-color: $main-bg-color;
    border-color: $border-color-light;

    .#{$parent}-icon {
      color: $primary-color;
    }
  }

  &-icon {
    align-self: flex-start;

    color: $warning-color;

    @include sm-and-down {
      width: 20px !important;
    }
  }

  &-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    width: 100%;
    margin-left: 16px;
  }

  &-closer {
    cursor: pointer;
  }
}
</style>
